function initializeSidebarToggle() {
    const sidebarTitles = document.querySelectorAll('.sidebar__title');
    
    if (!sidebarTitles.length) {
        return;
    }

    sidebarTitles.forEach(function(title) {
        const siblingList = findSibling(title, 'ul');
        const siblingSections = findSibling(title, '.sidebar__sections');

        // If a UL sibling was not found for this title, skip it.
        if (!siblingList && !siblingSections) {
            return;
        }
        
        // Add the click listener
        title.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Toggle the classes on the title and the UL sibling
            title.classList.toggle('is-active');
            if (siblingList) {
                siblingList.classList.toggle('is-open');
            }

            if (siblingSections) {
                siblingSections.classList.toggle('is-open');
            }
            
            // Update ARIA attribute
            const isExpanded = title.getAttribute('aria-expanded') === 'true';
            title.setAttribute('aria-expanded', !isExpanded);
        });
    });
}

function findSibling(element, selector) {
    let sibling = element.nextElementSibling;
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
    return null; // No matching sibling was found
}

function initializeSidebarToggleSubMenu() {
    const sidebarSvgs = document.querySelectorAll('.sidebar__left li.has-children svg');

    if (!sidebarSvgs.length) {
        return;
    }

    sidebarSvgs.forEach(function(svg) {
        const parentLi = svg.parentElement;

        const ul = parentLi.querySelector('ul');

        if (!ul || ul.tagName !== 'UL') {
            console.warn('Could not find a UL element for', svg);
            return;
        }

        svg.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            ul.classList.toggle('is-open');
            parentLi.classList.toggle('is-active');

            const isExpanded = svg.getAttribute('aria-expanded') === 'true';
            svg.setAttribute('aria-expanded', !isExpanded);
        });
    });

    const activeLinks = document.querySelectorAll('.sidebar__left li a.is-active');
    activeLinks.forEach(function(link) {
        const parentLi = link.parentElement;
        const ul = parentLi.querySelector('ul');
        if (ul) {
            ul.classList.add('is-open');
            parentLi.classList.add('is-active');
        }
    });
}

function initializeResponsiveHeroPadding() {
    const pageHero = document.querySelector('.page-hero');
    const sidebar = document.querySelector('.sidebar__left');

    // If the hero or sidebar elements don't exist on this page, do nothing.
    if (!pageHero || !sidebar) {
        return;
    }

    // Define the media query for mobile/tablet.
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    /**
     * The core function to add or remove the padding class based on screen size.
     */
    function updatePaddingClass() {
        if (mediaQuery.matches) {
            // If the screen is mobile/tablet size, add the class.
            pageHero.classList.add('page-hero--extra-padding');
        } else {
            // If the screen is larger, remove the class.
            pageHero.classList.remove('page-hero--extra-padding');
        }
    }

    // 1. Run the check once when the page first loads.
    updatePaddingClass();

    // 2. Add a listener to run the check again whenever the viewport
    //    crosses the breakpoint (e.g., on browser resize).
    mediaQuery.addEventListener('change', updatePaddingClass);
}

function initializeSidebarLeftMobileMenu() {
    const sidebarLabel = document.querySelector('.sidebar__left-label');
    const sidebarLeftList = document.querySelectorAll('.sidebar__left-list');
    const sidebarTopLink = document.querySelector('.sidebar__left-link');

    // If the hero or sidebar elements don't exist on this page, do nothing.
    if (!sidebarLabel || !sidebarLeftList) {
        return;
    }

    sidebarLabel.addEventListener('click', function(e) {
        e.preventDefault();
        sidebarLeftList.forEach(function(item) {
            item.classList.toggle('is-open');
        });

        sidebarTopLink.classList.toggle('is-open');

        const isExpanded = sidebarLabel.getAttribute('aria-expanded') === 'true';
        sidebarLabel.setAttribute('aria-expanded', !isExpanded);
    });
}

function initializeSidebarScrollToContent() {
    const sidebarLinks = document.querySelectorAll('.sidebar__left-list a');

    sidebarLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            sessionStorage.setItem('scrollToContent', '1');
        });
    });

    if (sessionStorage.getItem('scrollToContent')) {
        sessionStorage.removeItem('scrollToContent');
        const content = document.querySelector('.content-layout__main');
        if (content) {
            const offsetPosition = content.getBoundingClientRect().top + window.scrollY - 131;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
    }
}

function initCourseDates() {

    document.querySelectorAll('.course-dates-wrapper').forEach(wrapper => {

        const toggle = wrapper.querySelector('.course-dates-toggle');

        if (!toggle) {
            return;
        }

        const showText = toggle.dataset.showText;
        const hideText = toggle.dataset.hideText;

        toggle.addEventListener('click', (e) => {
            e.preventDefault();

            const isOpen = wrapper.classList.toggle('is-open');

            toggle.textContent = isOpen
                ? hideText
                : showText;
        });
    });
}

function initSidebar() {
    initializeSidebarToggle();
    initializeSidebarToggleSubMenu();
    initializeResponsiveHeroPadding();
    initializeSidebarLeftMobileMenu();
    initializeSidebarScrollToContent();
    initCourseDates();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebar);
} else {
    initSidebar();
}
